<template>
  <div :class="isPC() ? 'poprun_layout pc' : 'poprun_layout'">
    <!-- :style="isPC() ? { minWidth: '1024px', minHeight: '768px' } : {}" -->
    <NavBar v-if="!isPC()" :style="{ position: 'absolute' }" />
    <PcHeader v-if="isPC()" />
    <router-view />
  </div>
</template>

<script>
import { isPC } from "@/utils";
import NavBar from "./mobile/NavBar";
import PcHeader from "../components/pc/Header";
export default {
  name: "poprun_layout",
  components: { NavBar, PcHeader },
  data() {
    return {
      isPC,
    };
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/common";
.poprun_layout {
  &.pc {
    /* width: px_rem(1920px);
    height: px_rem(1080px); */
  }
  .nav-iconfont {
    font-size: 0.66667rem;
    color: #fff;
    cursor: pointer;
    position: fixed;
    top: 12.267vw;
    left: 5.333vw;
    z-index: 2;
  }
}
</style>
